import "./loader.css";
export default function Loader(props) {
  return (
    <span
      className="loader"
      style={{
        width: props.width,
        height: props.height,
      }}
    ></span>
  );
}
